import fwLogo from "../../assets/fw_logo_500x300.png";
import fwFooterLogo from "../../assets/fw_footer_logo.png";
import fwStoreInsightsBgImg from "../../assets/fw_store-insights-bgimg.png";
import fwLogo7x from "../../assets/fw_logo7x.png";

import hsBrandsLogo from "../../assets/hs_brands_logo_500x300.png";
import hsBrandsFooterLogo from "../../assets/hs_brands_logo_500x300.png";
import hsBrandsStoreInsightsBgImg from "../../assets/hs_brands_store-insights-bgimg.png";
import hsLogo7x from "../../assets/hs_brands_logo7x.png";

const tenants = {
  floorwalk: {
    name: "FloorWalk",
    hostName: "floorwalk.in",
    fullName: "FloorWalk Consultants Pvt. Ltd.",
    logo: fwLogo,
    logo7x: fwLogo7x,
    footerLogo: fwFooterLogo,
    storeInsightsBgImg: fwStoreInsightsBgImg,
    favicon: "/fw_favicon.ico",
    supportEmail: "contactus@floorwalk.in",
    supportContacts: [""], // not being used
    supportContactsShopper: "",
    supportContactsAccounts: "",
    auditorPortalUrl: "https://auditor.floorwalk.in/auditor/auth/login",
    socialMedia: {
      instagram: "https://www.instagram.com/floorwalk/",
      linkedin: "https://in.linkedin.com/company/floorwalk",
      facebook: "https://www.facebook.com/FloorWalk",
      twitter: "https://twitter.com/FloorWalk",
    },
    baseUrl: "https://portal.floorwalk.in",
    clientPortalUrl: "https://client.floorwalk.in",
    colors: {
      "--common-color": "#003c5d",
      "--blue-shade": "#007dc1",
      "--gray-shade": "#aaa",
      "--green-shade": "#8dc63f",
      "--danger-red-shade": "#d9534f",
    },
    features: {
      chatbot: true,
    },
  },

  hsbrandsasia: {
    name: "HS Brands",
    hostName: "hsbrandsasia.com",
    fullName: "HS Brands Private Limited",
    logo: hsBrandsLogo,
    logo7x: hsLogo7x,
    footerLogo: hsBrandsFooterLogo,
    storeInsightsBgImg: hsBrandsStoreInsightsBgImg,
    favicon: "/hs_brands_favicon.ico",
    supportEmail: "shopper.relations@hsbrandsasia.com",
    supportContacts: "+91-9663772288",
    supportContactsShopper: "+91-9663772288",
    supportContactsAccounts: "+91-8088940494",

    auditorPortalUrl: "https://auditor.hsbrandsasia.com",
    socialMedia: {
      instagram: "https://www.instagram.com/mystery_shopping_expert/",
      linkedin:
        "https://www.linkedin.com/company/hs-brands-international-asia/",
      facebook: "https://www.facebook.com/mysteryshoppingexpert",
      twitter: "https://x.com/HSBrands",
    },
    colors: {
      "--blue-shade": "#8f061e",
    },
    baseUrl: "https://portal.hsbrandsasia.com",
    clientPortalUrl: "https://client.hsbrandsasia.com",
    features: {
      chatbot: false,
    },
  },
};

export default tenants;
